class tableSwitcher {
  constructor(elem) {
    this.elem = elem;
    this.tables = this.elem.querySelectorAll(
      ".paragraph-funpass-price__table-item"
    );
    this.switcher = this.elem.querySelector(
      ".paragraph-funpass-price__table-switcher"
    );
    this.switchers = this.switcher.querySelectorAll("button");
    this.sibluTableSwitcher();
  }

  sibluElementsSwitcher(elements, index) {
    elements.forEach((el) => {
      if (el.classList.contains("active")) {
        el.classList.remove("active");
      }
    });

    if (!elements[index].classList.contains("active")) {
      elements[index].classList.add("active");
    }
  }

  sibluTableSwitcher() {
    this.elem.classList.add("paragraph-funpass-price__tables--processed");

    if (this.elem && this.switcher && this.tables.length) {
      this.tables.forEach((table, i) => {
        const caption = table.querySelector("caption");
        if (caption) {
          this.switchers[i].innerText = caption.textContent.trim();
        }
      });

      this.switchers.forEach((btn, i) => {
        if (btn.classList.contains("active")) {
          this.tables[i].classList.add("active");
        }

        btn.addEventListener("click", () => {
          this.sibluElementsSwitcher(this.switchers, i);
          this.sibluElementsSwitcher(this.tables, i);
        });
      });
    }
  }
}

const tableElems = document.querySelectorAll(
  ".paragraph-funpass-price__table:not(.paragraph-funpass-price__table--processed)"
);

for (let tableElem of tableElems) {
  tableElem.tableSwitcher = new tableSwitcher(tableElem);
}
